import React, { Component } from 'react';
import { Tabs } from 'antd';

import SalesSettings from 'components/scenes/sales/SalesSettings';
import SalesGeneralSettings from 'components/scenes/sales/SalesGeneralSettings';
import PhotoReportsSettings from 'components/scenes/photoReports/PhotoReportsSettings';

const { TabPane } = Tabs;

export default class Settings extends Component {
    getActiveKey = () => this.props.location.pathname.indexOf('/settings/photo') === 0 ? 'photo' : 'sales';

    onChange = key => {
        this.props.history.push(key === 'photo' ? '/settings/photo' : '/settings');
    }

    render() {
        return (
            <Tabs
                className='settings-tabs'
                activeKey={this.getActiveKey()}
                onChange={this.onChange}
            >
                <TabPane tab='Продажи' key='sales'>
                    <Tabs defaultActiveKey='periods'>
                        <TabPane tab='Периоды' key='periods'>
                            <SalesSettings />
                        </TabPane>
                        <TabPane tab='Общие' key='general'>
                            <SalesGeneralSettings />
                        </TabPane>
                    </Tabs>
                </TabPane>
                <TabPane tab='Фотоотчеты' key='photo'>
                    <PhotoReportsSettings />
                </TabPane>
            </Tabs>
        );
    }
}
